var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bounce-loader',{attrs:{"loading":_vm.isLoading,"color":'#68d391',"size":100}}),(!_vm.isLoading)?_c('px-assets-table',{attrs:{"assets":_vm.assets}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }